import React from 'react';

const ThumbUp = ({ filled, ...props }: React.SVGProps<SVGSVGElement> & { filled?: boolean }): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <mask
        id="mask0_1231_2831"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1231_2831)">
        {filled ? (
          <path
            d="M15 17H5.5V7L11.5 1L12.1667 1.45833C12.4167 1.63889 12.6007 1.86806 12.7188 2.14583C12.8368 2.42361 12.8611 2.70833 12.7917 3L12 7H17.5C17.9167 7 18.2708 7.14583 18.5625 7.4375C18.8542 7.72917 19 8.08333 19 8.5V9.6875C19 9.79861 18.9896 9.89931 18.9688 9.98958C18.9479 10.0799 18.9167 10.1736 18.875 10.2708L16.3958 16.0833C16.2708 16.3611 16.0833 16.5833 15.8333 16.75C15.5833 16.9167 15.3056 17 15 17ZM4 7V17H1V7H4Z"
            fill="currentColor"
          />
        ) : (
          <path
            d="M15 17H5.5V7L11.5 1L12.1667 1.45833C12.4028 1.625 12.5833 1.83681 12.7083 2.09375C12.8333 2.35069 12.8681 2.61806 12.8125 2.89583L12.7917 3L12 7H17.5C17.9167 7 18.2708 7.14583 18.5625 7.4375C18.8542 7.72917 19 8.08333 19 8.5V9.6875C19 9.79861 18.9896 9.89931 18.9688 9.98958C18.9479 10.0799 18.9167 10.1736 18.875 10.2708L16.3944 16.0875C16.2703 16.3625 16.0833 16.5833 15.8333 16.75C15.5833 16.9167 15.3056 17 15 17ZM7 15.5H15L17.5 9.6875V8.5H10.1667L11.1875 3.4375L7 7.625V15.5ZM5.5 7V8.5H2.5V15.5H5.5V17H1V7H5.5Z"
            fill="currentColor"
          />
        )}
      </g>
    </svg>
  );
};

export default ThumbUp;
